import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="bg-dark text-light py-4 text-center">
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <h5>Contatti</h5>
                        <ul className="list-unstyled">
                            <li><FaPhone className="me-2" /> +1 123 456 7890</li>
                            <li><FaEnvelope className="me-2" /> info@pizzeria.com</li>
                            <li><FaMapMarkerAlt className="me-2" /> Indirizzo della pizzeria, Città, Stato</li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <h5>Orari di apertura</h5>
                        <p>Lunedì - Venerdì: 10:00 - 22:00</p>
                        <p>Sabato - Domenica: 11:00 - 23:00</p>
                    </div>
                    <div className="col-md-4">
                        <h5>Seguici su</h5>
                        <ul className="list-unstyled">
                            <li>
                                <FaFacebook /> <a href="https://www.facebook.com/pizzeria" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
                            </li>
                            <li>
                                <FaInstagram />  <a href="https://www.instagram.com/pizzeria" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
                            </li>
                            <li>
                                <FaTwitter /><a href="https://twitter.com/pizzeria" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <p className="text-muted mt-4">
                            &copy; {currentYear} Pizzeria. Tutti i diritti riservati.
                        </p>
                    </div>
                    <div className="col">
                        <p className="text-muted mt-4">
                            Powered by Francesco Rossi.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;